import { create } from 'zustand';

interface HealthState {
  isConnected: boolean;
  setConnected: (connected: boolean) => void;
}

/** Store for TAK Server connection health status */
export const useHealthStore = create<HealthState>((set) => ({
  isConnected: false,
  setConnected: (connected) => set({ isConnected: connected }),
}));
